import {
  Button,
  Datagrid,
  FunctionField,
  NumberField,
  ReferenceManyField,
  SimpleList,
  TextField,
  type RaRecord,
} from "react-admin";
import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { formatINR } from "@/utils";
import { formatListDate } from "@/utils/date-format";

export const NiyaazShowReceipts = () => {
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"), { noSsr: true });
  return (
    <ReferenceManyField reference="niyaazReceipts" target="niyaazId" label={false}>
      {isSmall ? (
        <SimpleList
          primaryText={(record) => String(record.receiptNo)}
          secondaryText={(record) => (
            <>
              {String(record.HOFName)} · {formatINR(record.amount)}
              <br />
              {formatListDate(record.date)} · {String(record.mode)}
            </>
          )}
          tertiaryText={(record) => String(record.markaz || "—")}
          linkType="edit"
          rowSx={() => ({ borderBottom: 1, borderBottomColor: "divider" })}
        />
      ) : (
        <Box sx={{ overflowX: "auto", width: "100%" }}>
          <Datagrid rowClick="edit" bulkActionButtons={false} sx={{ minWidth: 960 }}>
            <TextField source="receiptNo" label="Receipt No" />
            <TextField source="formNo" label="Form No" />
            <TextField source="HOFId" label="HOF ID" />
            <TextField source="HOFName" label="HOF Name" />
            <FunctionField
              label="Date"
              source="date"
              render={(record: RaRecord) =>
                record?.date ? <span>{formatListDate(record.date as string)}</span> : <span>—</span>
              }
            />
            <NumberField source="amount" label="Amount" />
            <TextField source="mode" label="Mode" />
            <TextField source="markaz" label="Markaz" />
            <TextField source="namaazVenue" label="Namaaz Venue" />
            <NumberField source="total" label="Total" />
            <FunctionField
              label="Download"
              source="formNo"
              render={(record) => (
                <Button
                  onClick={() => {
                    window.open(`#/niyaaz-receipt?receiptId=${record.id}`, "_blank");
                  }}
                >
                  <DownloadIcon />
                </Button>
              )}
              key="name"
            />
          </Datagrid>
        </Box>
      )}
    </ReferenceManyField>
  );
};
